import { Box, Stack } from '@mui/material';
import { FormTypes } from '../constants';
import { AssemblyTemplateForm } from '../Assembly/AssemblyTemplateForm';
import { DefectLegendTemplateForm } from './DefectLegendTemplateForm';
import { PoiTemplateForm } from './PointOfInterest/PoiTemplateForm';
import { QuerySummaryTemplateForm } from './QuerySummaryTemplateForm';
import { StructureTemplateForm } from './StructureTemplateForm';
import { LogsTemplateForm } from '../Logs/LogsTemplateForm';

export const TemplateForm = ({
  currentTemplateType,
  handleEmptyForm = () => {},
  emptyForm = false,
  structureId,
  currentStructureName = '',
  structurePipesData,
}: {
  currentTemplateType: string;
  handleEmptyForm?: (value: boolean) => void;
  emptyForm?: boolean;
  structureId: string;
  currentStructureName?: string;
  structurePipesData?: { key: string; value: number };
}) => {
  return (
    <>
      {currentTemplateType === FormTypes.PointOfInterest.toString() && (
        <Stack width="100%">
          <Box width={'100%'} sx={{ paddingTop: 4 }}>
            <PoiTemplateForm
              emptyForm={emptyForm}
              handleEmptyForm={handleEmptyForm}
              structureId={structureId}
            />
          </Box>
        </Stack>
      )}
      {currentTemplateType === FormTypes.DefectLegends.toString() && (
        <DefectLegendTemplateForm structureId={structureId} />
      )}
      {currentTemplateType === FormTypes.Assembly.toString() && (
        <Stack width="100%">
          <Box width={'100%'} sx={{ paddingTop: 4 }}>
            <AssemblyTemplateForm
              emptyForm={emptyForm}
              handleEmptyForm={handleEmptyForm}
              structureId={structureId}
            />
          </Box>
        </Stack>
      )}
      {currentTemplateType === FormTypes.QuerySummary.toString() && (
        <Stack width="100%">
          <Box width={'100%'} sx={{ paddingTop: 4 }}>
            <QuerySummaryTemplateForm
              emptyForm={emptyForm}
              handleEmptyForm={handleEmptyForm}
              structureId={structureId}
            />
          </Box>
        </Stack>
      )}

      {currentTemplateType === FormTypes.Structure.toString() && (
        <Stack width="100%">
          <Box width={'100%'} sx={{ paddingTop: 4 }}>
            <StructureTemplateForm
              structureId={structureId}
              structurePipesData={structurePipesData}
            />
          </Box>
        </Stack>
      )}

      {currentTemplateType === FormTypes.Logs.toString() && (
        <Stack width="100%">
          <Box width={'100%'} sx={{ paddingTop: 4 }}>
            <LogsTemplateForm
              emptyForm={emptyForm}
              handleEmptyForm={handleEmptyForm}
              structureId={structureId}
              currentStructureName={currentStructureName}
            />
          </Box>
        </Stack>
      )}
    </>
  );
};
